import { render, staticRenderFns } from "./HMNoDataCard.vue?vue&type=template&id=88f3cd20&scoped=true&"
import script from "./HMNoDataCard.vue?vue&type=script&lang=js&"
export * from "./HMNoDataCard.vue?vue&type=script&lang=js&"
import style0 from "./HMNoDataCard.vue?vue&type=style&index=0&id=88f3cd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f3cd20",
  null
  
)

export default component.exports